<div [class.d-none]="!isLoading" class="loader-main">
  <app-circle-loader
    [loading]="isLoading"
    [fullHeight]="true"
  ></app-circle-loader>
</div>
